import { z } from "zod";
import { DATE_PRESETS } from "../enums";

export const objectId = z.string().regex(/^[a-f0-9]{24}$/i, "Identifiant invalide");

export const paginationQuery = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(25),
  sort: z.string().max(60).optional(),
  q: z.string().trim().max(200).optional(),
});
export type PaginationQuery = z.infer<typeof paginationQuery>;

export const dateRangeQuery = z.object({
  preset: z.enum(DATE_PRESETS).default("7d"),
  from: z.string().datetime({ offset: true }).optional(),
  to: z.string().datetime({ offset: true }).optional(),
});
export type DateRangeQuery = z.infer<typeof dateRangeQuery>;

export const moneyMinor = z.number().int("Montant invalide").min(0, "Montant invalide");
export const currencyCode = z.string().length(3).toUpperCase();

export const emailSchema = z.string().trim().toLowerCase().email("Adresse e-mail invalide").max(254);
export const passwordSchema = z
  .string()
  .min(10, "10 caractères minimum")
  .max(128, "128 caractères maximum")
  .regex(/[a-zA-Z]/, "Au moins une lettre")
  .regex(/\d/, "Au moins un chiffre");

export const addressSchema = z.object({
  name: z.string().trim().max(120).optional().default(""),
  phone: z.string().trim().max(40).optional().default(""),
  governorate: z.string().trim().max(60).optional().default(""),
  delegation: z.string().trim().max(80).optional().default(""),
  city: z.string().trim().max(80).optional().default(""),
  line1: z.string().trim().max(240).optional().default(""),
  zip: z.string().trim().max(12).optional().default(""),
  notes: z.string().trim().max(500).optional().default(""),
  country: z.string().length(2).toUpperCase().optional().default("TN"),
});
export type AddressInput = z.infer<typeof addressSchema>;

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ApiErrorBody {
  error: {
    code: string;
    message: string;
    details?: unknown;
  };
}
